import dayjs, { type Dayjs } from 'dayjs';
import type { DateRangePickerTimeUnit } from '../constants';

/**
 * @returns Period range corresponding to provided time value,unit and timeWindowShift combination relevant to provided dateTo(when not provided current date is used).
 */
export const getTimeValueUnitRange = (
  timeValue: number,
  timeUnit: DateRangePickerTimeUnit,
  timeWindowShift = 0,
  providedDateTo?: Dayjs,
): {
  dateFrom: Dayjs;
  dateTo: Dayjs;
} => {
  let dateTo = dayjs(providedDateTo).add(timeWindowShift * timeValue, timeUnit);
  const dateFrom = dayjs(providedDateTo)
    .subtract(timeValue - 1, timeUnit)
    .add(timeWindowShift * timeValue, timeUnit)
    .startOf(timeUnit);

  if (timeWindowShift !== 0) {
    dateTo = dateTo.endOf(timeUnit);
  }

  return { dateFrom, dateTo };
};
